<script lang="ts">
	import { formatDateTimeWithLocaleMinimize } from '$lib/utils/date';
	import AuthorsBox from './AuthorsBox.svelte';
	import InterviewerBox from './InterviewerBox.svelte';
	import Share from '$lib/components/Share.svelte';
	export let article;
</script>

{#if article && article.content}
	<div class="container md:text-left text-center mb-5 md:mb-1">
		{#if article.content.interview?.isInterview}
			<InterviewerBox interviewer={article?.content.interview} />
		{:else}
			<AuthorsBox authors={article.content.author} />
		{/if}

		<p class=" md:text-left text-center text-grey-dark">
			{formatDateTimeWithLocaleMinimize(article?.created_at)}
		</p>
		<Share
			linkedin
			twitter
			facebook
			roundedFull={false}
			buttonClassName="mr-1 bg-primary text-white"
		/>
	</div>
{/if}
